module.exports = __webpack_public_path__ + "common/icon-arrow-84f7f8dd3fff6ff66ad75cc301831ab4.svg";